// How the backend defines the state of a chat. After socket reconnections or page refreshes, the frontend requests all
// the agents' currently active chats. The backend will return a state ID so the frontend can determine if the customer
// has left the chat, or the it's mid-transfer etc.
export var ChatStateStatus;
(function (ChatStateStatus) {
    ChatStateStatus[ChatStateStatus["WaitingForAgent"] = 1] = "WaitingForAgent";
    ChatStateStatus[ChatStateStatus["Chatting"] = 2] = "Chatting";
    ChatStateStatus[ChatStateStatus["Transferring"] = 3] = "Transferring";
    ChatStateStatus[ChatStateStatus["CustomerGone"] = 4] = "CustomerGone";
    ChatStateStatus[ChatStateStatus["AgentWrapUp"] = 5] = "AgentWrapUp";
    ChatStateStatus[ChatStateStatus["Terminated"] = 6] = "Terminated";
    ChatStateStatus[ChatStateStatus["DeflectingCustomer"] = 7] = "DeflectingCustomer";
    ChatStateStatus[ChatStateStatus["OfflineDeflection"] = 8] = "OfflineDeflection";
})(ChatStateStatus || (ChatStateStatus = {}));
export default ChatStateStatus;
//# sourceMappingURL=chat-state-status.js.map